<template>
  <div class="flex flex-col gap-4">
    <div v-for="(cond, idx) in conditions" :key="idx">
      <component
        :is="componentMap[cond.type]"
        :condition="cond"
        :passageKey="passageKey"
        :securityCode="securityCode"
        :resolvedInstanceId="`${securityCode}-${cond.type}`"
        :make="make"
        :verifyData="verifyData"
        @verified="(ok: boolean) => handleVerified(ok, idx)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, onMounted } from 'vue'
import type { Condition } from '../types'

const emit = defineEmits<{ (e: 'changed', oks: boolean[]): void }>()
const props = defineProps<{
  conditions: Condition[]
  passageKey: string
  securityCode: string
  make: (c: Condition) => Promise<any>
  verifyData: { email: string; phone: string; loginType: number; unauthorized: boolean }
}>()

import SmsVerifier from './SmsVerifier.vue'
import EmailVerifier from './EmailVerifier.vue'
import AppVerifier from './AppVerifier.vue'
import PasskeyVerifier from './PasskeyVerifier.vue'

const componentMap: Record<string, any> = {
  sms_validate: SmsVerifier,
  email_validate: EmailVerifier,
  app_validate: AppVerifier,
  biometric_validate: PasskeyVerifier,
}

const okStates = reactive<boolean[]>(props.conditions.map(() => false))

const handleVerified = (ok: boolean, idx: number) => {
  okStates[idx] = !!ok
  emit('changed', okStates.map(Boolean))
}

onMounted(() => {
  emit('changed', okStates.map(Boolean))
})
</script>
